import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useSimActivityLogs } from 'lib/hooks/sim/sim.queries';
import moment from 'moment';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ACTIVITY_LOGS_PAGE_SIZE } from 'views/SIMDetail/config';

function ActivityLogs() {
  const { id: iccid } = useParams<{ id: string }>();

  const { data, isLoading, fetchNextPage, hasNextPage, isFetching } =
    useSimActivityLogs({
      iccid,
      limit: ACTIVITY_LOGS_PAGE_SIZE,
    });

  const activityLogs = data?.pages.map((p) => p.data).flat();

  const noActivitiesFound =
    !isLoading && activityLogs && activityLogs.length === 0;

  const LoadMoreButton = (
    <div className="text-center">
      <button
        className="btn mt-3"
        onClick={() => fetchNextPage()}
        style={{ color: 'purple' }}
      >
        {isFetching ? 'Loading...' : 'Load More'}
      </button>
    </div>
  );

  const renderContent = () => {
    if (isLoading) return <LoadingState />;
    if (noActivitiesFound) return <EmptyState />;
    else
      return (
        <div className="card-body card-body-sm">
          <ul className="usage-activity">
            {activityLogs?.map((l) => (
              <Log key={l.id} content={l.text} date={l.date} />
            ))}
          </ul>

          {hasNextPage && LoadMoreButton}
        </div>
      );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card mt-5">
          <div className="card-header d-flex align-items-center">
            <h5 className="card-title">Activity Logs</h5>
          </div>

          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default ActivityLogs;

function Log(props: { date: string; content: string }) {
  const { date, content } = props;

  const dateText = moment(date)
    .tz(moment.tz.guess())
    .format('MMM DD, YYYY h:mm a z');

  return (
    <li>
      {dateText} - <span dangerouslySetInnerHTML={{ __html: content }} />
    </li>
  );
}

function LoadingState() {
  return (
    <div className="card-body p-0">
      <div className="table-responsive">
        <table className="table custom-table-secondary">
          <tbody>
            <tr>
              <td data-testid="loading-spinner">
                <Spin
                  spinning={true}
                  size="large"
                  style={{ width: '100%' }}
                  indicator={
                    // @ts-ignore
                    <LoadingOutlined
                      style={{ fontSize: 30, color: '#000' }}
                      spin
                    />
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="card-body p-0">
      <div className="table-responsive">
        <table className="table custom-table-secondary">
          <tbody>
            <tr>
              <td>
                <span className="font-16">No Activities Available.</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
